import api from "@/api";
import translate from "@/helpers/translate"
import {parseJwt} from '@/helpers/helpers'
import Vue from 'vue';

const accessToken = localStorage.getItem("access_token");
const anonymousToken = localStorage.getItem("anonymous_token");
const refreshToken = localStorage.getItem("refresh_token");
const userGuid = localStorage.getItem("user_guid");
const userInfoStorage = JSON.parse(localStorage.getItem('userInfoStorage'))
const defaultUserInfo = {
    role: "user",
    organizations: [],
    sites: [],
    question_access: {

    }
}

export default {
    namespaced: true,

    state: {
        currentQuestionUid: null,
        userInfo: userInfoStorage || defaultUserInfo,
        userGuid: userGuid,
        guid: null,
        accessToken: accessToken,
        refreshToken: refreshToken,
        anonymousToken: anonymousToken,
        hasPlace: false,
    },

    getters: {
        isAuthorized(state) {
            return state.accessToken != null
        },

        getUserInfo(state) {
            return state.userInfo
        },
        getQuestionUid(state) {
            return state.currentQuestionUid
        },
        getQuestionManageData(state) {
            return state.userInfo.question_access
        },

        getAnonymousTokenDataFromState(state) {
            return {
                token: state.anonymousToken,
                guid: state.guid
            }
        },
    },

    mutations: {
        setAnonymousToken(state, {token, guid}) {
            state.anonymousToken = token;
            state.guid = guid;
            localStorage.setItem("guid", guid);
            localStorage.setItem("anonymous_token", token);
        },

        resetAnonymousToken(state) {
            state.anonymousToken = null;
            state.guid = null;
            localStorage.removeItem("anonymous_token");
            localStorage.removeItem("guid");
        },

        setAccessToken(state, {accessToken, refreshToken}) {
            state.accessToken = accessToken
            state.refreshToken = refreshToken
            localStorage.setItem("access_token", accessToken)
            localStorage.setItem("refresh_token", refreshToken)
            let jwtData = parseJwt(accessToken)
            localStorage.setItem("ssid", jwtData.ssid)
        },

        setUser(state, user) {
            state.userGuid = user;
            localStorage.setItem("user_guid", user);
        },

        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem('userInfoStorage', JSON.stringify(userInfo))
            if (userInfo.organization || userInfo.organizations.length) {
                state.isMultipleSites = userInfo.organization ? userInfo.organization.multiple : userInfo.organizations[0].multiple
                localStorage.setItem('isMultipleSites', state.isMultipleSites)
            } else {
                state.isMultipleSites = false
            }
            let lang = userInfo.setups.lang_code;
            if (lang && lang !== 'null' && (lang == 'ru' && lang == 'en' && lang == 'uk')) {
                (new Vue()).$ml.change(lang)
                state.currentLanguage = lang
                localStorage.setItem('lang', lang)
            }
        },

        removeKeys(state) {
            console.log('remover started')
            state.accessToken = null
            state.refreshToken = null
            state.userGuid = null
            state.userInfo = defaultUserInfo
            localStorage.removeItem('access_token');
            localStorage.removeItem('ssid');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user_guid');
            localStorage.removeItem('userInfoStorage');
            localStorage.removeItem('makeOwnerBool');
            localStorage.removeItem('isMultipleSites');
            sessionStorage.removeItem('unlinked_rate');
            sessionStorage.removeItem('unlinked_rate_question');
            sessionStorage.removeItem('unlinked_rate_question_location');
            console.log('remover success')
        },
        setQuestionUid(state, value) {
            state.currentQuestionUid = value;
        },
    },
    actions: {

        async signUpFaceBook(context, {token, questionsUids}) {
            const url = "/auth/facebook";
            const data = {facebook_token: token, start_tpl_uids: questionsUids};
            return await api.request("post", url, data);
        },

        async signUpGoogle(context, {token, questionsUids}) {
            const url = "/auth/google";
            const data = {google_token: token, start_tpl_uids: questionsUids};
            return await api.request("post", url, data);
        },
        async logIn(context, body) {
            const url = "/auth/airvote/sign-in";

            return await api.request("post", url, body)
        },
        async pinLogIn(context, body) {
            const url = "/auth/airvote/sign-in/pin";

            return await api.request("post", url, body)
        },
        async registration(context, body) {
            const url = '/auth/airvote/sign-up';

            return await api.request("post", url, body)
        },
        async sendLocationError(context, body) {
            const url = '/api/admin/voteGeolocationError'

            const response = await api.request("post", url, body)
            return response.data;
        },
        async sendLocationAllowedPopup(context, body) {
            const url = '/api/admin/gpsAllowedPopup'

            const response = await api.request("post", url, body)
            return response.data;
        },
        async sendGpsPopupAsked(context, body) {
            const url = '/api/admin/gpsPopupAsked'

            const response = await api.request("post", url, body)
            return response.data;
        },
        async sendGpsRequested(context, body) {
            const url = '/api/admin/gpsRequested'

            const response = await api.request("post", url, body)
            return response.data;
        },
        async sendGpsLoadingPopupHide(context, body) {
            const url = '/api/admin/gpsLoadingPopupHide'

            const response = await api.request("post", url, body)
            return response.data;
        },

        async fetchUserInfo(context) {
            let url = `/users/${context.state.userGuid}`;
            console.log(`kek lol: ${context.state.currentQuestionUid}`)
            if(context.state.currentQuestionUid != null) {
                url += `?q_uid=${context.state.currentQuestionUid}`
            }
            const response = await api.request("get", url);
            context.commit("setUserInfo", response.data);
            return response.data;
        },

        async logout(context) {
            const url = `/auth/logout`;
            return await api.request("post", url)
        },

        async saveLog(context, text) {
            try {
                let time = (new Date()).getTime()
                console.log(`save log:\n${text}`)
                const url = '/api/log';
                let body = {text: `${time}: ${text}`}
                return await api.request("post", url, body)
            } catch (error) {
                console.log(`unable to send log:`, error)
                return ':('
            }
        },

        async sendRateLog(context, {action, question_uid, vote_uid, additional_data}) {
            try {
                const url = '/api/admin/rateRateLog'
                let body = {
                    question_uid: question_uid,
                    vote_uid: vote_uid,
                    action: action,
                    date: (new Date()).toISOString(),
                    additional_data: additional_data,
                }
                const response = await api.request("post", url, body)
                return response.data;
            } catch (error) {
                console.log(`unable to send log:`, error)
                return ':('
            }
        },

    }
};
